import React from 'react';
import OnboardingStep, { OnboardingContext } from './OnboardingStep';
import styles from './FamilyMatchConfirmationStep.module.css';
import { FamilySummary } from 'gql/types';
import noUser from '../../assets/no-user.png';
import FamilyMemberList from 'components/profile/family/FamilyMemberList';

interface FamilyMatchConfirmationStepProps {
  onboardingContext: OnboardingContext;
  family: FamilySummary;
  onConfirm: () => void;
  onReject: () => void;
}

const FamilyMatchConfirmationStep: React.FC<FamilyMatchConfirmationStepProps> = ({
  onboardingContext,
  family,
  onConfirm,
  onReject,
}) => {
  const spouseProfilePic = family.parents.length == 0
    ? noUser
    : (family.parents[0].profilePictureUrl ?? noUser);

  onboardingContext = {
    removeTopPadding: true,
    ...onboardingContext,
  }

  return (
    <OnboardingStep
      onboardingContext={onboardingContext}
      title="We matched you to your family based on the information your family provided."
      subtitle={""}
      onContinue={onConfirm}
      buttonEnabled={true}
      primaryButtonText={"Confirm"}
      secondaryButtonText={"This is Not Correct"}
      onSkip={onReject}
    >
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          <div className={styles.imageWrapper}>
            {/* Profile Picture Preview */}
            <img
              src={spouseProfilePic}
              alt="Family Profile Picture"
              className={styles.imagePreview}
            />
            {/* Camera Button */}
          </div>
        </div>
        <div className={styles.familyMemberContainer}>
          <FamilyMemberList family={family} />
        </div>
      </div>
    </OnboardingStep>
  );
};

export default FamilyMatchConfirmationStep;
